import { useEffect } from 'react';

import { useLocation } from '@remix-run/react';

declare global {
  interface Window {
    gtag: any;
  }
}

interface PixelProps {
  pixelId: string;
  marketingCookies: boolean;
}

const GAPixel = ({ pixelId, marketingCookies }: PixelProps) => {
  const location = useLocation();

  // Fire page view on eaxch route change
  useEffect(() => {
    try {
      if (window.gtag) {
        window.gtag('config', pixelId, {
          page_path: location.pathname,
        });
      }
    } catch {
      /*swallow exception*/
    }
  }, [location, pixelId]);

  useEffect(() => {
    let script1: HTMLScriptElement | null = null;
    let script2: HTMLScriptElement | null = null;

    try {
      // match valid pixel id: UA- followed by 6+ digits, optional - and digit
      if (pixelId?.match(/^UA-\d{6,}(-\d)?$/) && marketingCookies) {
        script1 = document.createElement('script');
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${pixelId}`;
        document.head.appendChild(script1);

        script2 = document.createElement('script');
        script2.async = true;
        script2.id = 'ga-pixel';
        script2.innerHTML = `
      (function(){try{
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
      }catch{/*swallow exception*/}})();
      `;
        document.head.appendChild(script2);
      }
    } catch {
      /*swallow exception*/
    }

    // Return cleanup function for both scripts
    return () => {
      try {
        if (script1?.parentNode) {
          script1.parentNode.removeChild(script1);
        }
      } catch {
        // Script already removed, safe to ignore
      }
      try {
        if (script2?.parentNode) {
          script2.parentNode.removeChild(script2);
        }
      } catch {
        // Script already removed, safe to ignore
      }
    };
  }, [pixelId, marketingCookies]);

  return null;
};

export default GAPixel;
